module.exports = __webpack_public_path__ + "img/horizontal-bg-en.e2105613.png";